import { humanize } from 'underscore.string';

export const Categories = {
  TERMINAL: 'Terminal',
  LINE: 'Line',
  USDA: 'USDA',
  OTHER: 'Other',
  CUSTOMS: 'Customs',
  CTF: 'CTF',
  PIER_PASS: 'pier_pass',
  HANDLING: 'handling',
  PER_DIEM: 'per_diem',
  CHASSIS: 'chassis',
  YARD_DEMURRAGE: 'yard_demurrage',
};

export const onHoldReasons = Object.keys(Categories).map((item) => {
  return {
    name: humanize(Categories[item]),
    value: `${item}`.toLocaleLowerCase(),
  };
});
